/**
 *
 */
export enum UserType {
    SUPERADMIN = "superAdmin",
    SUPERUSER = "superUser",
    ADMIN = "admin",
    ENGINEER = "engineer",
    USER = "user",
}